import { Box, Grid, GridItem, Heading, Link, SimpleGrid, Text, Container, Stack } from "@chakra-ui/react";
import React from "react";
import parser from "html-react-parser";
import MotionBox from "./motion-box";

const HeroBlock = ({ page, block }) => {

    return (
        <Box className="home-header-container" backgroundImage={`url(${block.img})`} backgroundPosition="center center" backgroundSize="cover" minHeight="100vh">
            <Container maxW={'5xl'}>
                <Stack
                    textAlign={'center'}
                    align={'center'}
                    spacing={{ base: 8, md: 10 }}
                    py={{ base: 20, md: 28 }}>
                    <MotionBox
                        w="100%"
                        opacity="0"
                        initial={{
                            translateY: 180
                        }}
                        animate={{
                            translateY: 0,
                            opacity: 1,
                            transition: {
                                delay: 0.4,
                                duration: 0.5
                            }
                        }}
                    >
                        <Heading
                            as={'h1'}
                            fontFamily="american"
                            fontWeight={600}
                            fontSize={{ base: '3xl', sm: '4xl', md: '6xl' }}
                            color="white"
                            lineHeight={'100%'}
                            textShadow="2px 2px 8px rgba(0,0,0,0.5)"
                            mt={{ base: 20, md: 0 }}>
                            {block.title}{' '}
                            <Text as={'div'} fontFamily="brush" fontWeight={500}
                                fontSize={{ base: '6rem', md: '13rem' }} color="white" textShadow="2px 2px 8px rgba(0,0,0,0.5)" mt="6rem">
                                Bellefonte
                            </Text>
                        </Heading>
                    </MotionBox>
                </Stack>

            </Container>
        </Box>
    )
};

export default HeroBlock;